import { useInfiniteQuery } from "@tanstack/react-query";
import { getRecordedCalls, GetRecordedCallsResponse } from "../actions/get-recorded-calls.action";


type UseRecordedCallsQueryParams = {
    limit?: number;
    enabled?: boolean;
    phoneNumber?: string;
};

export const useRecordedCallsQuery = ({
    limit = 10,
    enabled = true,
    phoneNumber,
}: UseRecordedCallsQueryParams = {}) => {
    return useInfiniteQuery<GetRecordedCallsResponse>({
        queryKey: ["recorded-calls", limit, phoneNumber],
        initialPageParam: 1,
        staleTime: 0,
        gcTime: 0,
        refetchOnMount: "always",
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        queryFn: ({ pageParam }) =>
            getRecordedCalls({
                page: pageParam as number,
                limit,
                phoneNumber,
            }),
        getNextPageParam: (lastPage) => {
            const hasMore = lastPage.page < lastPage.totalPages;
            return hasMore ? lastPage.page + 1 : undefined;
        },
        enabled,
    });
};